import html2canvas from "html2canvas";

export default html2canvas;
